import { Menu } from "lucide-react";

export default function Navbar({ toggleSidebar }) {
  return (
    <div className="bg-white shadow px-6 py-4 flex justify-between items-center">
      <div className="flex items-center gap-4">
        <button
          onClick={toggleSidebar}
          className="p-2 rounded hover:bg-gray-200"
        >
          <Menu size={22} />
        </button>

        <input
          type="text"
          placeholder="Search..."
          className="border rounded px-3 py-1"
        />
      </div>

      <div>Admin</div>
    </div>
  );
}